{
  "OninboundalertingPara": "Você pode ativar alarmes quando as chamadas recebidas alertam por muito tempo.",
  "OntalktimePara": "Você também pode ativar alarmes quando qualquer chamada atingir um limite de tempo de conversação.",
  "OninboundalertingLabel": "No alerta de entrada sobre:",
  "OntalktimeLabel": "Sobre o tempo de conversação:",
  "OninboundalertingEnabledHiddenlabel": "O alerta de entrada sobre a configuração está ativado?",
  "OntalktimeEnabledHiddenlabel": "O tempo de conversação sobre a configuração está ativado?",
  "OninboundalertingPlaceholder": "15s",
  "OntalktimePlaceholder": "5m 0s",
  "CallStateThresholds_SectionHeader": "Limites de estado de chamada",
  "NAME": "CallStateThresholds"
}